/* @ngInject */
export default function ($scope, AuthService, $timeout, LayoutService, $stateParams, toastr, TrainingCourses, $state, PreferencesService) {
	$scope.courseId           = $stateParams.courseId;
	$scope.loading            = true;
	$scope.loadingModules     = true;
	$scope.loadingUserSummary = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.refresh = () => {
		$scope.loading            = true;
		$scope.loadingModules     = true;
		$scope.loadingUserSummary = true;

		TrainingCourses.one($scope.courseId)
		               .get({
			               include: 'modules',
		               })
		               .then((course) => {
			               $scope.course = course;

			               if ($scope.course.modules && $scope.course.modules.length > 0) {
				               $scope.course.modules = $scope.course.modules.filter((module) => {
					               return module.available === true;
				               });

				               $scope.course.modules.sort((a, b) => {
					               return a.sort - b.sort;
				               });
			               }

			               $scope.updateLayout($scope.course.name);

			               $scope.loadingModules = false;

			               if (!$scope.loadingUserSummary) {
				               if ($scope.course.modules && $scope.course.modules.length > 0) {
					               $scope.course.modules = $scope.course.modules.map((module) => {
						               let lastAttempt = null;

						               let attempts = $scope.userSummary.filter((attempt) => {
							               return attempt.module.id === module.id;
						               });

						               if (attempts.length > 0) {
							               if (attempts.length > 1) {
								               attempts.sort((a, b) => {
									                       return a.timeCompleted - b.timeCompleted;
								                       })
								                       .reverse();
							               }

							               lastAttempt = attempts[0];
						               }

						               return {
							               ...module,
							               lastAttempt,
						               };
					               });
				               }

				               $scope.loading = false;
			               }
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this course, please try again.', 'Error');

			               $state.go('staff.training.completion.root');

			               $scope.loading = false;
		               });

		TrainingCourses.one($scope.courseId)
		               .one('user-summaries', AuthService.getUser().id)
		               .get({
			               include: 'module',
		               })
		               .then((userSummary) => {
			               $scope.userSummary = userSummary;

			               $scope.loadingUserSummary = false;

			               if (!$scope.loadingModules) {
				               if ($scope.course.modules && $scope.course.modules.length > 0) {
					               $scope.course.modules = $scope.course.modules.map((module) => {
						               let lastAttempt = null;

						               let attempts = $scope.userSummary.filter((attempt) => {
							               return attempt.module.id === module.id;
						               });

						               if (attempts.length > 0) {
							               if (attempts.length > 1) {
								               attempts.sort((a, b) => {
									                       return a.timeCompleted - b.timeCompleted;
								                       })
								                       .reverse();
							               }

							               lastAttempt = attempts[0];
						               }

						               return {
							               ...module,
							               lastAttempt,
						               };
					               });
				               }

				               $scope.loading = false;
			               }
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while loading this course, please try again.', 'Error');

			               $state.go('staff.training.completion.root');

			               $scope.loading = false;
		               });
	};

	$scope.updateLayout = (courseName = 'Loading...') => {
		LayoutService.reset();

		LayoutService.setTitle([
			courseName,
			'Complete Training',
			'Training',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.training.root',
				             displayName: 'Training',
			             },
			             {
				             route:       'staff.training.completion.root',
				             displayName: 'Complete Training',
			             },
			             {
				             route:       `staff.training.completion.view({ moduleId: "${$scope.courseId}" })`,
				             displayName: courseName,
			             },
		             ]);

		LayoutService.getPageHeader()
		             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		LayoutService.getPageHeader()
		             .onClicked(() => {
			             $scope.refresh();
		             });
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/completion/view/controller.js